module.exports = __webpack_public_path__ + "img/A58A1209_min.e11cf81b.jpg";